import { BrandfolderHexColors } from '../enums/colors.js';

const defaultTableDark = {
    backgroundColor: BrandfolderHexColors.Title,
    tbodyBorderColor: BrandfolderHexColors.GrayDark,
    theadBorderColor: BrandfolderHexColors.GrayMedium,
    textColor: BrandfolderHexColors.White,
    trHoverBackgroundColor: BrandfolderHexColors.Text
};
const defaultTableLight = {
    backgroundColor: BrandfolderHexColors.White,
    tbodyBorderColor: BrandfolderHexColors.Gray,
    theadBorderColor: BrandfolderHexColors.Text,
    textColor: BrandfolderHexColors.Text,
    trHoverBackgroundColor: BrandfolderHexColors.Marshmallow
};

export { defaultTableDark, defaultTableLight };
//# sourceMappingURL=table.js.map
